var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as _ from 'lodash';
import { Messages } from 'primereact/messages';
import * as React from 'react';
import { withRouter } from 'react-router-dom';
import * as RitualFactory from '../../../classes/definitions/ritual/ritual';
import ApiRequests from '../../../classes/http/ApiRequests';
import HttpRequests from '../../../classes/http/HttpRequests';
import NotosService from '../../../classes/notos.service';
import AppRoutes from '../../../config/appRoutes';
import Config from '../../../config/config';
import ritualSchema from '../../../schemas/ritualSchema';
import Input from '../../UI/Input/Input';
var RitualForm = /** @class */ (function (_super) {
    __extends(RitualForm, _super);
    function RitualForm() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.api = new ApiRequests();
        _this.http = new HttpRequests();
        _this.editId = '';
        _this.messages = null;
        _this.staticPageId = '';
        _this.imageChanged = false; // this will determine if the image has been changed
        // if no changes, no image prop will be sent to the backend
        _this.state = {
            formConfig: _.cloneDeep(ritualSchema),
            formIsValid: false,
            discardPopupVisble: false,
            productsSuggestions: [],
        };
        _this.getRitual = function (id) {
            _this.api
                .getRitual(id)
                .then(function (response) {
                _this.setDataToForm(_.get(response, 'data.data', {}));
            })
                .catch(function (error) {
                var defaultMessage = 'Грешка при зареждане на ритуал';
                _this.http.handleError(error, _this.messages, defaultMessage, _this.props.history);
            });
        };
        _this.setDataToForm = function (data) {
            var ritual = RitualFactory.createRitual(_.get(data, 'attributes', {}));
            var imageUrl = ritual.ImageUrl ? Config.cdnDomain + ritual.ImageUrl : null;
            var updatedFormConfig = __assign({}, _this.state.formConfig);
            _.set(updatedFormConfig, 'youtube_url.value', ritual.YoutubeUrl);
            _.set(updatedFormConfig, 'youtube_url.touched', true);
            _.set(updatedFormConfig, 'youtube_url.valid', true);
            _.set(updatedFormConfig, 'position.value', ritual.Position);
            _.set(updatedFormConfig, 'position.touched', true);
            _.set(updatedFormConfig, 'position.valid', true);
            console.log('ritual', ritual);
            _.set(updatedFormConfig, 'products.value', ritual.ProductsFormatted);
            _.set(updatedFormConfig, 'products.touched', true);
            _.set(updatedFormConfig, 'products.valid', true);
            _.set(updatedFormConfig, 'image_url.value', imageUrl);
            _.set(updatedFormConfig, 'image_url.touched', true);
            _.set(updatedFormConfig, 'image_url.valid', true);
            _this.setState({
                formConfig: updatedFormConfig,
                formIsValid: NotosService.checkFormValidity(updatedFormConfig),
            });
        };
        // handles input and blur events
        _this.eventHandlers = function (event, id, eventType, elType) {
            var updatedFormConfig = __assign({}, _this.state.formConfig);
            var updatedFormElement = __assign({}, updatedFormConfig[id]);
            if (elType === 'autocomplete') {
                if (event.value) {
                    updatedFormElement.value = event.value;
                }
            }
            else {
                updatedFormElement.value = event.target.value;
            }
            if (id === 'image_url' && updatedFormElement.valid) {
                _this.imageChanged = true;
            }
            updatedFormElement.valid = NotosService.checkFieldValidity(updatedFormElement.value, updatedFormElement.validation, eventType);
            updatedFormElement.touched = true;
            updatedFormConfig[id] = updatedFormElement;
            _this.setState({
                formConfig: updatedFormConfig,
                formIsValid: NotosService.checkFormValidity(updatedFormConfig),
            });
        };
        _this.submitForm = function (event) {
            event.preventDefault();
            var formData = _this.state.formConfig;
            var submittedRitual = new FormData();
            var image = _.get(formData, 'image_url.value', null);
            var ritualFromData = RitualFactory.createRitual({
                bg_name: _.get(formData, 'bg_name.value', ''),
                en_name: _.get(formData, 'en_name.value', ''),
                position: _.get(formData, 'position.value', 0),
                products: _.get(formData, 'products.value', []),
            });
            submittedRitual.append('ritual[youtube_url]', _.get(formData, 'youtube_url.value', ''));
            submittedRitual.append('ritual[position]', _.get(formData, 'position.value', 50));
            if (ritualFromData.Products) {
                for (var _i = 0, _a = ritualFromData.Products; _i < _a.length; _i++) {
                    var element = _a[_i];
                    submittedRitual.append('ritual[product_ids][]', element.toString());
                }
            }
            if (_this.editId && _this.imageChanged && !image) {
                submittedRitual.append('ritual[remove_image]', '1');
            }
            else if (_this.editId && _this.imageChanged && image) {
                submittedRitual.append('ritual[image]', image);
            }
            else if (!_this.editId.length && _this.imageChanged && image) {
                // probably pointless, have to test
                submittedRitual.append('ritual[image]', image);
            }
            var actionMethod = _this.editId === '-1' ? _this.api.createRitual : _this.api.updateRitual;
            actionMethod(submittedRitual, _this.editId !== '-1' ? _this.editId : undefined)
                .then(function (response) {
                _this.toRitualsPage();
            })
                .catch(function (error) {
                var defaultMessage = 'Грешка при създаване на ритуал';
                _this.http.handleError(error, _this.messages, defaultMessage, _this.props.history);
            });
        };
        _this.toRitualsPage = function () {
            _this.props.history.push(AppRoutes.rituals.path);
        };
        _this.suggestOptions = function (event, type) {
            var searchString = event.query.toLowerCase();
            _this.api
                .searchProducts(searchString)
                .then(function (response) {
                var data = _.get(response, 'data.data', []);
                var results = [];
                for (var _i = 0, data_1 = data; _i < data_1.length; _i++) {
                    var item = data_1[_i];
                    results.push({
                        label: _.get(item, 'attributes.name', ''),
                        value: _.get(item, 'id'),
                    });
                }
                var obj = {};
                obj['productsSuggestions'] = results;
                _this.setState(obj);
            })
                .catch(function (error) {
                var defaultMessage = 'Не можахме да намерим опции';
                _this.http.handleError(error, _this.messages, defaultMessage, _this.props.history);
            });
        };
        return _this;
    }
    RitualForm.prototype.componentDidMount = function () {
        this.editId = _.get(this.props, 'match.params.ritualId', '-1');
        if (this.editId !== '-1') {
            this.getRitual(this.editId);
        }
    };
    RitualForm.prototype.render = function () {
        var _this = this;
        var _a = this.state, formConfig = _a.formConfig, formIsValid = _a.formIsValid, productsSuggestions = _a.productsSuggestions;
        var formElementsArray = [];
        // turning the formConfig from an object to an array
        for (var key in formConfig) {
            if (formConfig.hasOwnProperty(key)) {
                formElementsArray.push({
                    config: formConfig[key],
                    id: key,
                });
            }
        }
        // Building form inputs
        var form = formElementsArray.map(function (formElement) {
            return (React.createElement(Input, { key: formElement.id, id: formElement.id, elementType: formElement.config.elementType, elementConfig: formElement.config.elementConfig, label: formElement.config.label, className: formElement.config.className, value: formElement.config.value, invalid: !formElement.config.valid, shouldValidate: formElement.config.validation, touched: formElement.config.touched, errorMsg: formElement.config.errorMsg, maxLength: formElement.config.maxLength, multiple: true, changed: function (event) {
                    return _this.eventHandlers(event, formElement.id, 'onChange', formElement.config.elementType);
                }, blur: function (event) {
                    return _this.eventHandlers(event, formElement.id, 'onBlur', formElement.config.elementType);
                }, suggestions: productsSuggestions, completeMethod: function (event) { return _this.suggestOptions(event, formElement.id); } }));
        });
        var actionBtns = (React.createElement("div", { className: "modal-footer" },
            React.createElement("button", { className: "btn btn-sm btn-outline-primary", onClick: this.toRitualsPage, type: "button" },
                React.createElement("i", { className: "fa fa-ban" }),
                " \u041E\u0442\u043A\u0430\u0437"),
            React.createElement("button", { className: "btn btn-sm btn-primary", onClick: this.submitForm, disabled: !formIsValid, type: "button" },
                React.createElement("i", { className: "fa fa-dot-circle-o" }),
                " OK")));
        return (React.createElement(React.Fragment, null,
            React.createElement(Messages, { ref: function (el) {
                    _this.messages = el;
                } }),
            form,
            actionBtns));
    };
    return RitualForm;
}(React.Component));
// @ts-ignore
export default withRouter(RitualForm);



//////////////////
// WEBPACK FOOTER
// ./src/components/Rituals/RitualForm/RitualForm.tsx
// module id = 441
// module chunks = 0